import config from 'config';
import { createContext, useContext, useMemo, useState } from 'react';

const StateContext = createContext({
    userDetails: null,
    open: false,
    setOpen: () => {},
    MenuOpen: [], // for active default menu
    setMenuOpen: () => {},
    menu: true,
    setMenu: () => {},
    fontFamily: config.fontFamily,
    setFontFamily: () => {},
    borderRadius: config.borderRadius,
    setBorderRadius: () => {}
});

export const ContextProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState([]);
    const [menu, setMenu] = useState(true);
    const [fontFamily, setFontFamily] = useState(config.fontFamily);
    const [borderRadius, setBorderRadius] = useState(config.borderRadius);

    const MENU_OPEN = (id) => setMenuOpen([id]);

    const SET_MENU = (state) => setMenu(state);

    const SET_FONT_FAMILY = (f) => setFontFamily(f);

    const SET_BORDER_RADIUS = (r) => setBorderRadius(r);
    const values = useMemo(
        () => ({
            open,
            setOpen,
            menuOpen,
            MENU_OPEN,
            menu,
            SET_MENU,
            fontFamily,
            SET_FONT_FAMILY,
            borderRadius,
            SET_BORDER_RADIUS
        }),
        [open, setOpen, menuOpen, MENU_OPEN, menu, SET_MENU, fontFamily, SET_FONT_FAMILY, borderRadius, SET_BORDER_RADIUS]
    );
    return <StateContext.Provider value={values}>{children}</StateContext.Provider>;
};

export const useStateContext = () => useContext(StateContext);
